import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { PushEventOnViewDirective } from './directive/push-event-on-view.directive'

@NgModule({
  imports: [CommonModule],
  declarations: [PushEventOnViewDirective],
  exports: [PushEventOnViewDirective]
})
export class AtsAnalyticsDirectivesPushEventOnViewModule {}
